module.exports = __webpack_public_path__ + "static/media/celek2.53e9807d.jpg";